var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTooltipTail = function SvgTooltipTail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.768 1c.77-1.333 2.694-1.333 3.464 0l3.464 6c.77 1.333-.192 3-1.732 3H2.036C.496 10-.466 8.333.304 7l3.464-6Z",
    fill: "#31363A"
  })));
};
export default SvgTooltipTail;